import React from 'react';
import { Typography } from '@material-ui/core';
import useStyles from './styles';
import clsx from 'clsx';
import { get } from 'global/lib/lodash';

export const Text = (props) => {
  const { type, bold, italic } = props;
  const classes = useStyles();
  return <Typography {...props} className={clsx(get(classes, type), props.className, bold && classes.bold, italic && classes.italic)} />;
};
